import { createContext } from 'react';

export interface ISplitPanelContext {
    openPanel: () => void,
    closePanel: () => void,
    panelContent?: JSX.Element,
    setPanelContent: (body: JSX.Element | undefined, header: string) => void,
}

export const SplitPanelContext = createContext<ISplitPanelContext>({
    openPanel: () => {},
    closePanel: () => {},
    setPanelContent: () => {},
});
